import { useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { useNotifications } from "./useNotifications";

/**
 * Sincroniza el contador de notificaciones no leídas con el badge
 * del ícono de la app (home screen) en iOS y Android.
 *
 * No-op en web. Falla silenciosamente si el plugin no está disponible
 * o el launcher no soporta badges (algunos Android stock).
 */
export const useAppBadge = () => {
  const { unreadCount } = useNotifications();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let cancelled = false;

    (async () => {
      try {
        const { Badge } = await import("@capawesome/capacitor-badge");
        if (cancelled) return;

        // Verificar soporte antes de intentar (algunos launchers Android no soportan)
        const supported = await Badge.isSupported().catch(() => ({ isSupported: true }));
        if (!supported?.isSupported) return;

        // Pedir permiso en iOS si no se ha otorgado (silencioso en Android)
        try {
          const perm = await Badge.checkPermissions();
          if (perm.display !== "granted") {
            await Badge.requestPermissions();
          }
        } catch {
          // Algunas plataformas no implementan permisos; continuar
        }

        if (cancelled) return;

        if (unreadCount > 0) {
          await Badge.set({ count: unreadCount });
        } else {
          await Badge.clear();
        }
      } catch (err) {
        console.warn("[useAppBadge] No se pudo actualizar el badge:", err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [unreadCount]);
};
